"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../../features/global/globalSlice");
var SavedSearchTable_1 = __importDefault(require("./SavedSearchTable"));
var ConfirmModal_1 = __importDefault(require("../../Modals/ConfirmModal"));
var NoResult_1 = __importDefault(require("../../NoResult/NoResult"));
var SavedSearch = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var types = {
        icon: 'icon-ic-saved-search',
        title: "" + t('SAVED_SEARCH.YOU_ARE_NOT_FOLLOWING_ANY_SEARCH'),
        description: "" + t('SAVED_SEARCH.WHEN_YOU_FOLLOWING_YOUR_SEARCH'),
    };
    var _a = react_1.useState(false), isOpenModal = _a[0], setIsOpenModal = _a[1];
    var _b = react_1.useState(), selectedSearchItemId = _b[0], setSelectedSearchItemId = _b[1];
    var savedSearches = react_redux_1.useSelector(globalSlice_1.useSelectSavedSearches);
    var dispatch = react_redux_1.useDispatch();
    react_1.useEffect(function () {
        window.scroll(0, 0);
    }, []);
    var onRemove = function (id) {
        setIsOpenModal(!isOpenModal);
        setSelectedSearchItemId(id);
    };
    var handleCancel = function () { return setIsOpenModal(!isOpenModal); };
    var removeSavedSearchItem = function () {
        setIsOpenModal(!isOpenModal);
        dispatch(globalSlice_1.removeFromSavedSearch(Number(selectedSearchItemId)));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ConfirmModal_1.default, { open: isOpenModal, cancelButtonTitle: t('Account.DeleteSearchItem.CANCEL_BUTTON'), confirmButtonTitle: t('Account.DeleteSearchItem.CONFIRM_BUTTON'), content: t('Account.DeleteSearchItem.TEXT'), headerTitle: t('Account.DeleteSearchItem.TITLE'), onCancel: handleCancel, onConfirm: removeSavedSearchItem }),
        react_1.default.createElement("div", { className: "account-saved" },
            react_1.default.createElement("h1", null, t('Account.SAVED_SEARCH.TITLE')),
            savedSearches.length === 0 ? (react_1.default.createElement("div", { className: "no-result flex-middle" },
                react_1.default.createElement(NoResult_1.default, __assign({}, types)))) : (react_1.default.createElement(SavedSearchTable_1.default, { savedSearches: savedSearches, onRemove: onRemove })))));
};
exports.default = SavedSearch;
